var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"escaner-camara"},[_c('video',{ref:"video",attrs:{"muted":"","playsinline":"","autoplay":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }